window.bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");